module.exports = __webpack_public_path__ + "img/vuejs-black.ad2354a1.png";